import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabase = createClient(supabaseUrl, supabaseKey, {
	auth: {
		// Recovery links generated by user-api use Supabase's client-side
		// implicit flow. Keep URL detection and persistence explicit so the
		// recovery session is available before the password form is shown.
		flowType: "implicit",
		detectSessionInUrl: true,
		persistSession: true,
		autoRefreshToken: true,
	},
});

export default supabase;
